<ng-container *ngIf="form">
  <div class="title-row">
    <div class="title-container">
      <span class="title">Incident ID: {{ form.get('incidentId').value !== 0 ? form.get('incidentId').value : 0 }}</span>
      <div class="status-chip" [ngClass]="form.get('status').value === 1 ? 'finalized' : 'draft'">
        <mat-icon>{{ form.get('status').value === 1 ? 'check_circle' : 'schedule' }}</mat-icon>
        <span class="chip" >{{ form.get('status').value === 1 ? 'Finalized' : 'Draft' }}</span>
      </div>
      <span>
        <b>
          <a href='assets/docs/MARS_2.5_Submission_Corrective_Actions.pdf' target="_blank">MARS Incident Help</a>
        </b>
      </span>
    </div>

    <div class="title-container">
      <span>*Required</span>
      <button 
        *ngIf="(form.get('createUser').value === user.email && form.get('status').value === 0) || user.isMarsAdmin" 
        mat-button 
        class="warning-btn"
        (click)="confirmDeleteIncident(form.get('incidentId').value)"
        >
        Delete Incident
      </button>
    </div>
  </div>
  <app-modal
    [active]="modal.active"
    [data]="modal.data"
    (confirmed)="modalConfirmed($event)"
    (denied)="modalDenied($event)"
  >
  </app-modal>
  <div class="row creation-row">
    <div class="value-column">
      <span class="label">Created By</span>
      <span class="value">{{ form.get('createUser').value }}</span>
    </div>
    <div class="value-column">
      <span class="label">Created Date</span>
      <span class="value">{{ formatDate(form.get('createDate').value) }}</span>
    </div>
    <div class="value-column">
      <span class="label">Last edited by</span>
      <span class="value">{{ form.get('modifyUser').value }}</span>
    </div>
    <div class="value-column">
      <span class="label">Edit Date</span>
      <span class="value">{{ formatDate(form.get('modifyDate').value) }}</span>
    </div>
  </div>
  <div class="row row-margin">
    <mat-form-field>
      <mat-label>Malfunction Date</mat-label>
      <input (dateChange)="onMalfunctionDateChange($event)" matInput [matDatepicker]="picker" [formControl]="form.get('malfunctionDate')" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Base</mat-label>
      <mat-select [formControl]="form.get('homeBase1')" (selectionChange)="onBaseChange($event)">
        <mat-option *ngFor="let base of homeBases" [value]="base.baseCode">
          {{ base.text }} | {{ base.baseCode }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('homeBase1').hasError('required')">Base is required</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Spike Base</mat-label>
      <mat-select [formControl]="form.get('spikeBaseId')" (selectionChange)="onSpikeBaseChange($event)">
        <mat-option *ngFor="let base of spikeBases" [value]="base.id">
          {{ base.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row row-margin">
    <mat-form-field>
      <mat-label>Classification</mat-label>
      <mat-select
        [formControl]="form.get('classificationId')"
        (selectionChange)="checkClassification($event)"
      >
        <mat-option [value]="1">Jumper Related</mat-option>
        <mat-option [value]="2">Paracargo Related</mat-option>
        <mat-option [value]="3">Aircraft Related</mat-option>
        <mat-option [disabled]="true" *ngIf="form.get('classificationId').value === 0" [value]="0">Unclassified, please classify</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('classificationId').hasError('required')"
        >Classification is required</mat-error
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label>MARS Type</mat-label>
      <mat-select
        [formControl]="form.get('classificationTypeId')"
        (selectionChange)="checkClassificationType($event)"
      >
        <mat-option [value]="1">Parachute</mat-option>
        <mat-option [value]="2">Gear / Equipment</mat-option>
        <mat-option [value]="3">Procedure</mat-option>
        <mat-option [disabled]="true" *ngIf="form.get('classificationTypeId').value === 0" [value]="0">Unclassified, please classify</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('classificationTypeId').hasError('required')"
        >MARS Type is required</mat-error
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label>Category</mat-label>
      <mat-select
        [formControl]="form.get('categoryId')"
        (selectionChange)="onCategoryChange($event)"
      >
        <mat-option *ngFor="let category of categories$ | async" [value]="category.categoryId">
          {{ category.categoryName }}
        </mat-option>
        <mat-option [disabled]="true" *ngIf="form.get('categoryId').value === 0" [value]="0">Unclassified, please classify</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('categoryId').hasError('required')"
        >Category is required</mat-error
      >
    </mat-form-field>
  </div>
    <div class="row">
      <div *ngIf="isMalfunctionType">
        <mat-form-field>
          <mat-label>Malfunction Type</mat-label>
          <mat-select [formControl]="form.get('malfunctionTypeId')" (selectionChange)="onMalfunctionTypeChange($event)">
            <mat-option
              *ngFor="let malfunction of malfunctionTypes$ | async"
              [value]="malfunction.malfunctionTypeId"
            >
              {{ malfunction.malfunctionTypeName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  <div *ngIf="form?.get('incidentId')?.value !== 0">
    <div class="row">
      <mat-checkbox
        class="margin-right"
        color="primary"
        [formControl]="form.get('incorrectProcedure')"
        >Incorrect Procedure?</mat-checkbox
      >
      <mat-checkbox class="margin-right" color="primary" [formControl]="form.get('inServiceError')"
        >In-Service Error?</mat-checkbox
      >
      <mat-checkbox class="margin-right" color="primary" [formControl]="form.get('inspectionError')"
        >Inspection Error?</mat-checkbox
      >
    </div>
    <div class="row checkbox-row">
      <mat-checkbox class="margin-right" color="primary" [formControl]="form.get('manufacturingError')">Manufacturing Error</mat-checkbox>
      <mat-checkbox class="margin-right" color="primary" [formControl]="form.get('cargoInTow')">Cargo-in-Tow</mat-checkbox>
    </div>
    <div class="madb-card">
      <span class="sub-header">Master Action Information</span>
      <div class="row">
        <mat-form-field class="form-field madb-field">
          <mat-label>MADB Incident</mat-label>
          <input
            #madbIncidentInput
            type="text"
            aria-label="MADB Incident"
            matInput
            [formControl]="form.get('madbIncident')"
            [matAutocomplete]="auto"
            (input)="onMadbIncidentInput($event)"
          />
          <mat-autocomplete
            autoActiveFirstOption
            #auto="matAutocomplete"
            (optionSelected)="setMadbIncident($event)"
            [displayWith]="madbIncidentsDisplay"
          >
            <mat-option *ngFor="let incident of madbIncidentList" [value]="incident">
              {{ incident.incidentName }} | {{ incident.baseCode }}
            </mat-option>
          </mat-autocomplete>
          <mat-spinner
            *ngIf="loading$ | async"
            [diameter]="30"
            style="float: right; margin-top: -30px"
          ></mat-spinner>
        </mat-form-field>
        <button mat-button class="primary-btn" (click)="clearMadbData()" [disabled]="form.get('status').value=== 1">
          Clear Master Action Data
        </button>
      </div>
      <div class="row">
        <mat-form-field class="form-field">
          <mat-label>Mission</mat-label>
          <mat-select [formControl]="form.get('mission')">
            <mat-option *ngFor="let mission of missions" [value]="mission">
              {{ mission }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label>Mode</mat-label>
          <mat-select [formControl]="form.get('mode')">
            <mat-option *ngFor="let mode of modes" [value]="mode">
              {{ mode }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label>To Area</mat-label>
          <mat-select [formControl]="form.get('toArea')">
            <mat-option *ngFor="let area of areas$ | async" [value]="area.id">
              {{ area.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="form-field">
          <mat-label>Yards of Drift</mat-label>
          <mat-select [formControl]="form.get('yardsDrift')">
            <mat-option *ngFor="let yard of yardsOfDrift" [value]="yard">
              {{ yard }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label>Aircraft</mat-label>
          <input
            type="text"
            aria-label="Aircraft"
            matInput
            [formControl]="form.get('aircraft')"
            [matAutocomplete]="aircraftAuto"
          />
          <mat-autocomplete
            #aircraftAuto="matAutocomplete"
            (optionSelected)="onAircraftChange($event.option.value)"
            [displayWith]="aircraftDisplay"
          >
            <mat-option *ngFor="let aircraft of filteredAircafts$ | async" [value]="aircraft">
              {{ aircraft.Aircraft_Name }} | {{ aircraft.Aircraft_Tail_Number }} |
              {{ aircraft.homeBase }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>Jump Type</mat-label>
        <mat-select [formControl]="form.get('jumpType')">
          <mat-option value="na">N/A</mat-option>
          <mat-option value="training">Training</mat-option>
          <mat-option value="fire">Fire</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Fire Name</mat-label>
        <input matInput type="text" [formControl]="form.get('fireName')" />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>Jump-spot Elevation</mat-label>
        <input matInput type="text" (input)="updateJumpElevation($event)" [formControl]="form.get('jumpSpotElevationMSL')" />
        <mat-hint>Feet</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Streamer Time</mat-label>
        <input matInput type="text" [formControl]="form.get('streamerTime')" />
        <mat-hint>Seconds</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Temperature</mat-label>
        <input matInput type="text" [formControl]="form.get('temp')" />
        <mat-hint>&deg;F</mat-hint>
      </mat-form-field>
    </div>
  </div>
</ng-container>
